import React, { useCallback, useRef } from "react";
import { ListItem } from "@mui/material";
import TaskCard from "./TaskCard";
import { Draggable } from "react-beautiful-dnd";
import { getStyle } from "common/utilities";
import { TaskCardProps } from "model/activitiesModel";

interface DraggableTaskCardProps extends TaskCardProps {
  index: number;
  lastElementRef?: (node: any) => void;
  onHeightChange?: (index: number, height: number) => void;
}
const DraggableTaskCard: React.FC<DraggableTaskCardProps> = ({
  index,
  lastElementRef,
  onHeightChange,
  ...props
}) => {
  const observerRef = useRef<ResizeObserver | null>(null);
  const measureRef = useCallback((row: HTMLLIElement | null) => {
    observerRef.current?.disconnect();
    observerRef.current = null;
    if (!row || !onHeightChange) return;
    const measure = () => onHeightChange(index, row.offsetHeight);
    measure();
    const observer = new ResizeObserver(measure);
    observer.observe(row);
    observerRef.current = observer;
  }, [index, onHeightChange]);

  return (
    <Draggable isDragDisabled={props.task.loading} draggableId={`${props.task.idprocesstoken}`} index={index}>
      {(provided, snapshot) => (
        <ListItem
          ref={(node) => {
            measureRef(node);
            provided.innerRef(node);
            lastElementRef && lastElementRef(node);
          }}
          {...provided.draggableProps}
          {...provided.dragHandleProps}
          id={`${props.task.state === 1 ? "doing-task" : "todo-task"}-${
            props.task.idprocesstoken
          }`}
          sx={{
            display: "flex",
          }}
          style={{paddingTop: 0, paddingBottom: props.view === 'minimal' ? 4 : 10, ...getStyle(
            provided.draggableProps.style,
            snapshot,
            props.task.state === 1,
          )}}
        >
          <TaskCard {...props} />
        </ListItem>
      )}
    </Draggable>
  );
};
export default DraggableTaskCard;
